export class tDishesModel {
    
    ID: number;
    dishesDesc: string;
    dishesDescENG: string;
    dishesCatID:number;
    dishesCatName:string;
    unitID:number;
    unitDesc:string;
    shopID: number;
    lastModifyDatetime: Date;
    lastModifyUserID: string;
    inActive: string;

}





